import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { AutoTranslatedPatientMessageContent } from "@/modules/chats/components/chat-message/patient-content/auto-translated-patient-message-content"
import { NonAutoTranslatedPatientMessageContent } from "@/modules/chats/components/chat-message/patient-content/non-auto-translated-patient-message-content"
import { LiveTranslationView, SofiaChatMessage } from "@/modules/chats/types/chat-message"
import { ChatPatient } from "@/modules/chats/types/chat-thread"
import { Language } from "@/types/__generated__/union-types"

interface PatientMessageContentRouterProps {
  message: SofiaChatMessage
  appointmentId: string
  patient: ChatPatient
  patientLanguage: Language
  liveTranslation: LiveTranslationView
}

export const PatientMessageContentRouter = (props: PatientMessageContentRouterProps) => {
  const messageContent = props.message.content
  const autoTranslatedContent = props.message.metadata?.autoTranslationTranslatedContent
  const autoTranslationTargetLanguage = props.message.metadata?.autoTranslationTargetLanguage
  const hasAutoTranslationFailed = props.message.metadata?.autoTranslationFailed === true

  const isLiveTranslationForSelectedLanguage =
    props.liveTranslation.isLiveTranslationEnabled &&
    autoTranslationTargetLanguage !== undefined &&
    autoTranslationTargetLanguage === props.liveTranslation.selectedTargetLanguage

  if (isLiveTranslationForSelectedLanguage) {
    return (
      <AutoTranslatedPatientMessageContent
        patientOriginalContent={messageContent}
        autoTranslatedContent={autoTranslatedContent}
        hasTranslationFailed={hasAutoTranslationFailed}
        patientLanguageCode={convertLanguageToISOCode(props.patientLanguage)}
      />
    )
  }

  return (
    <NonAutoTranslatedPatientMessageContent
      patientOriginalContent={messageContent}
      appointmentId={props.appointmentId}
      patient={props.patient}
    />
  )
}
